import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBoxesStacked, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import Items from '../Setup/Users/Items';
import ItemsCategory from '../Setup/Users/ItemsCategory';
import Loader from '../Layout/Loader';
import SettingsTabs from './SettingsTabs';
import useSettingsCompany from './useSettingsCompany';
import SettingsBreadcrumb from './SettingsBreadcrumb';
import './settings.scss';

const ProductsSettings = () => {
  const { t } = useTranslation('translations');
  const {
    company,
    loading,
    isAdminMode,
    getBackUrl,
  } = useSettingsCompany();

  if (loading || !company) {
    return <Loader />;
  }

  return (
    <div className="settings-subpage">
      <SettingsBreadcrumb
        items={[{ label: t('settings.productsCatalog') }]}
        company={company}
        isAdminMode={isAdminMode}
      />

      <div className="settings-subpage__header">
        <Link to={getBackUrl()} className="settings-subpage__back-btn">
          <FontAwesomeIcon icon={faArrowLeft} />
        </Link>
        <h2 className="settings-subpage__title">
          <span className="settings-subpage__icon">
            <FontAwesomeIcon icon={faBoxesStacked} />
          </span>
          {t('settings.productsCatalog')}
        </h2>
        {company && (
          <span className="settings-subpage__company-badge">
            {company.name}
          </span>
        )}
      </div>

      <SettingsTabs
        variant="card"
        tabs={[
          {
            id: 'products',
            label: t('navbar.products'),
            content: <Items />,
          },
          {
            id: 'categories',
            label: t('navbar.itemsCategory'),
            content: <ItemsCategory />,
          },
        ]}
      />
    </div>
  );
};

export default ProductsSettings;
